import { Review } from "schema-dts";

import { DispensaryReview, ProductReview } from "@/custom-types/Reviews";

export default (
  reviews: DispensaryReview[] | ProductReview[] = [],
): Review[] => {
  return reviews.map((review) => ({
    "@type": "Review",
    author: {
      "@type": "Person",
      name: review.user.username,
    },
    datePublished: review.created,
    description: review.text,
    reviewRating: {
      "@type": "Rating",
      ratingValue: review.rating,
    },
  }));
};
